import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { anularFumigado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionEliminarFumigadoView } from '../components/OperacionEliminarFumigadoView'

export const OperacionEliminarFumigado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionEliminarFumigadoView
        silo={silo}
        aceptar={async () => {
          try {
            await anularFumigado(silo)
            closeDialog()
            enqueueSnackbar('Anulado de fumigado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Anulado de fumigado incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('ELIMINAR_FUMIGADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
